import React, { useEffect, useState } from "react";

// Full-size photo viewer (4.10.55, 2026-10-26): the Review Places photos are
// small thumbnails, but they're often the best clue to what a place is (a
// landmark in the background). Opens on the 🔍 button; ← → (or the
// keyboard arrows) step through the place's photos; Esc or a click outside
// closes it. photos: [{ src, name }], index: the one to show first.
const PhotoViewer = ({ photos, index, onClose }) => {
  const [i, setI] = useState(index || 0);
  const count = photos?.length || 0;
  useEffect(() => {
    // Caught first (capture) and stopped there: Esc closes just the photo,
    // not the Review Places window behind it.
    const onKey = (e) => {
      if (!["Escape", "ArrowRight", "ArrowLeft"].includes(e.key)) return;
      e.stopPropagation();
      e.preventDefault();
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") setI((x) => Math.min(count - 1, x + 1));
      if (e.key === "ArrowLeft") setI((x) => Math.max(0, x - 1));
    };
    window.addEventListener("keydown", onKey, true);
    return () => window.removeEventListener("keydown", onKey, true);
  }, [count, onClose]);
  if (!count) return null;
  const photo = photos[i];
  const arrow = { position: "absolute", top: "50%", transform: "translateY(-50%)", border: "none", borderRadius: 24, width: 48, height: 48, background: "rgba(255,255,255,0.85)", fontSize: 24, cursor: "pointer" };
  return (
    <div
      className="photo-viewer"
      role="dialog"
      aria-label="Photo"
      onClick={onClose}
      style={{ position: "fixed", inset: 0, zIndex: 80000, background: "rgba(0,0,0,0.88)", display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <img
        src={photo.src}
        alt={photo.name || ""}
        referrerPolicy="no-referrer"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: "94vw", maxHeight: "86vh", objectFit: "contain", borderRadius: 6 }}
      />
      <button type="button" aria-label="Close" onClick={onClose} style={{ position: "absolute", top: 14, right: 14, border: "none", borderRadius: 20, width: 40, height: 40, fontSize: 20, background: "rgba(255,255,255,0.85)", cursor: "pointer" }}>
        ✕
      </button>
      {i > 0 ? (
        <button type="button" aria-label="Previous photo" onClick={(e) => { e.stopPropagation(); setI(i - 1); }} style={{ ...arrow, left: 14 }}>‹</button>
      ) : null}
      {i < count - 1 ? (
        <button type="button" aria-label="Next photo" onClick={(e) => { e.stopPropagation(); setI(i + 1); }} style={{ ...arrow, right: 14 }}>›</button>
      ) : null}
      <div style={{ position: "absolute", bottom: 14, left: 0, right: 0, textAlign: "center", color: "#fff", fontSize: 13 }}>
        {count > 1 ? `${i + 1} of ${count}` : ""}
      </div>
    </div>
  );
};

export default PhotoViewer;
